import CookiesJS from 'cookies-js';

export function initUser($, apiClient) {
    // Множественный выбор без выбранных пунктов отдаёт null, а не пустой
    // массив. Сервер такое поле отклоняет: «не заполнено» и «явный null» —
    // разные вещи для валидатора, и весь запрос падает с 400.
    //
    // Из-за этого нельзя было создать пользователя вообще: у нового
    // не выбрано ни ролей, ни исключённых продуктов.
    function multi(id) {
        return $(`#${id}`).val() || [];
    }

    function extractRecommendations(field) {
        const items = [];
        $(`#${field} .array-item .array-item-value`).each(function () {
            items.push({
                text: $(this).val(),
            });
        });
        return items;
    }

    $('form.user-form .action__entity-save').on('click', async function () {
        try {
            const _id = $(this).attr('data-object-id');
            const trainings = [];
            const practices = [];
            // Если назначенная тренировка, практика или программа удалена,
            // селект показывает «Не выбрано» и отдаёт пустую строку. Сервер
            // ждёт идентификатор и отклоняет ВЕСЬ запрос — из-за одной такой
            // строки нельзя сохранить ни код тренера, ни что-либо ещё.
            // Поэтому строки без идентификатора не отправляем.
            $('#trainings .array-item').each(function () {
                const trainingId = $(this).find('select.trainings-trainingId').val();
                if (!trainingId) return;
                trainings.push({
                    trainingId,
                    weekDays: $(this).find('select.trainings-weekDays').val(),
                });
            });
            $('#practices .array-item').each(function () {
                const practiceId = $(this).find('select.practices-practiceId').val();
                if (!practiceId) return;
                practices.push({
                    practiceId,
                    time: $(this).find('.practices-time').val(),
                    weekDays: $(this).find('select.practices-weekDays').val(),
                });
            });
            // Ручная настройка расчёта. Отправляем её, только если специалист
            // что-то поменял: иначе каждое сохранение карточки проверяло бы
            // старую настройку заново, и после смены веса нельзя было бы
            // сохранить даже телефон. При смене цели не отправляем вовсе —
            // сервер сбросит настройку сам, она относилась к прежней цели.
            let statsOverrides;
            const $overrides = $('.stats-overrides');
            const goalChanged = $overrides.length
                && ($('#goalCode').val() || '') !== ($overrides.attr('data-initial-goal') || '');
            if ($overrides.length && !goalChanged) {
                const fields = [
                    ['#overrideCalorieModifier', 'calorieModifier', 100],
                    ['#overrideProtein', 'protein', 1],
                    ['#overrideFat', 'fat', 100],
                ];
                let dirty = false;
                const collected = {};
                for (const [selector, key, divider] of fields) {
                    const $input = $(selector);
                    if (!$input.length) continue;
                    const raw = String($input.val() || '').trim();
                    const initial = String($input.attr('data-initial') || '').trim();
                    if (raw !== initial) dirty = true;
                    if (raw !== '') {
                        const value = parseFloat(raw.replace(',', '.'));
                        if (!isNaN(value)) collected[key] = value / divider;
                    }
                }
                // Пустой объект — законный результат: все поля очищены,
                // значит вернуть значения по умолчанию.
                if (dirty) statsOverrides = collected;
            }

            // Анкета активности: код вопроса -> код ответа. Скрытые зависимые
            // вопросы не отправляем — сервер их всё равно отбросит, а так
            // не создаём впечатления, что ответ сохранён.
            let activity;
            const $activity = $('.activity-form');
            if ($activity.length) {
                activity = {};
                $activity.find('.activity-question').each(function () {
                    const $question = $(this);
                    if ($question.is(':hidden')) return;
                    const code = $question.attr('data-question');
                    const value = $question.find('.activity-answer').val();
                    if (code && value) activity[code] = value;
                });
                if (!Object.keys(activity).length) activity = undefined;
            }

            const user = {
                name: $('#name').val(),
                surname: $('#surname').val(),
                code: $('#code').val(),
                // Привязка меняется кодом, а не идентификатором: API читает
                // только inviterCode. Пустая строка означает «отвязать»,
                // поэтому отправляем её как есть, а не через || undefined.
                inviterCode: $('#inviterCode').val(),
                comment: $('#comment').val(),
                sex: parseInt($('#sex').val()),
                status: parseInt($('#status').val()),
                email: $('#email').val(),
                phone: $('#phone').val(),
                deficit: parseInt($('#deficit').val()) || 0,
                lockDeficit: !!$('#lockDeficit').prop('checked'),
                height: parseInt($('#height').val()),
                weight: parseInt($('#weight').val()),
                birthYear: parseInt($('#birthYear').val()),
                level: parseInt($('#level').val()),
                goals: multi('goals'),
                // Пустые не отправляем вовсе: сервер отклоняет попытку стереть
                // цель, и из-за незаполненного поля у старого пользователя
                // нельзя было бы сохранить ничего другого в карточке.
                statsOverrides,
                activity,
                goalCode: $('#goalCode').val() || undefined,
                dietTypeCode: $('#dietTypeCode').val() || undefined,
                programmsUpdatePeriod: $('#programmsUpdatePeriod').val(),
                equipment: multi('equipment'),
                contraindications: multi('contraindications'),
                trainings,
                // Программы этой формой не сохраняются: сервер их в PATCH
                // игнорирует, у блока «Программы» своя кнопка и свой запрос.
                // Раньше поле отправлялось и создавало ложное впечатление,
                // что общее сохранение их меняет.
                practices,
                recommendations: extractRecommendations('recommendations'),
                meals: [
                    !!$('#meals0').prop('checked'),
                    !!$('#meals1').prop('checked'),
                    !!$('#meals2').prop('checked'),
                    !!$('#meals3').prop('checked'),
                    !!$('#meals4').prop('checked'),
                    !!$('#meals5').prop('checked')
                ],
                activityCoefficient: $('#activityCoefficient').val(),
                maxRecipeDifficulty: $('#maxRecipeDifficulty').val(),
                maxRecipePrice: $('#maxRecipePrice').val(),
                disallowedProducts: multi('disallowedProducts'),
                disallowedKitchenware: multi('disallowedKitchenware'),
                roles: multi('roles'),
                deleted: !!$('#deleted').prop('checked'),
            };

            if (!_id) {
                const result = await apiClient.create('/users', user, CookiesJS.get('auth_token'));
                console.log(result);
                document.location.href=`/users/edit/${result._id}`;
            } else {
                const result = await apiClient.updateOne('/users', _id, user, CookiesJS.get('auth_token'));
                console.log(result);
                alert('Сохранено');
                location.reload();
            }
        } catch(e) {
            console.warn(e);
            if (e.response
                && e.response.data
                && e.response.data.errors
                && e.response.data.errors[0]
                && e.response.data.errors[0].msg
            ) {
                alert(`${e.response.data.errors[0].msg}: ${e.response.data.errors[0].param}`);
            } else {
                alert(e);
            }
        }
    });

    // Зависимые вопросы анкеты активности: длительность и плотность
    // силовых не нужны тому, кто силовые не делает. Правило приходит
    // с сервера в data-depends-*, шаблон о самих вопросах ничего не знает.
    function refreshActivityDependencies() {
        $('.activity-question[data-depends-on]').each(function () {
            const $question = $(this);
            const parent = $question.attr('data-depends-on');
            const notEquals = $question.attr('data-depends-not');
            const parentValue = $(`.activity-question[data-question="${parent}"] .activity-answer`).val();
            const visible = !!parentValue && parentValue !== notEquals;
            $question.toggle(visible);
            if (!visible) $question.find('.activity-answer').val('');
        });
    }
    $('.activity-form').on('change', '.activity-answer', refreshActivityDependencies);
    refreshActivityDependencies();

    $('form.user-form .action__user-programms-save').on('click', async function () {
        try {
            const _id = $(this).attr('data-object-id');
            const programms = [];
            // См. комментарий выше: строки с удалённой программой отдают
            // пустой идентификатор и роняют весь запрос.
            $('#programms .array-item').each(function () {
                const programmId = $(this).find('select.programms-programmId').val();
                if (!programmId) return;
                programms.push({
                    programmId,
                    weekDays: $(this).find('select.programms-weekDays').val(),
                });
            });

            if (!_id) {
                alert('Невозможно назначить программы для несуществующего пользователя');
            } else {
                const result = await apiClient.updateUserProgramms(_id, {programms}, CookiesJS.get('auth_token'));
                console.log(result);
                alert('Сохранено');
                location.reload();
            }
        } catch(e) {
            console.warn(e);
            if (e.response
                && e.response.data
                && e.response.data.errors
                && e.response.data.errors[0]
                && e.response.data.errors[0].msg
            ) {
                alert(`${e.response.data.errors[0].msg}: ${e.response.data.errors[0].param}`);
            } else {
                alert(e);
            }
        }
    });
}
